module.exports = __webpack_public_path__ + "static/media/gw.b43dd312.webp";